import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useLearnerCoachingEnabled } from '@/hooks/useLearnerCoachingEnabled'
import { useMyCoach } from '@/hooks/useMyCoach'
import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

/** The one definition of "coaching is on for the signed-in learner": flag, learner role, and `coaching_enabled`. */
export function useLearnerCoaching() {
  const flagEnabled = useLearnerCoachingEnabled()
  const { userRole, isLoaded: isRoleLoaded } = useRole()
  const { user } = useCurrentUser()
  const isLearner = userRole === ClerkUserRole.LEARNER
  const { coach, loadError } = useMyCoach(flagEnabled && isLearner ? (user?.id ?? null) : null)
  const coachingEnabled = isLearner && coach?.coaching_enabled === true

  return { isRoleLoaded, isLearner, coach, loadError, coachingEnabled }
}
